export enum PaymentStatusEnum {
  STATUS_NEW = 'STATUS_NEW',
  STATUS_IN_PROCESS = 'STATUS_IN_PROCESS',
  STATUS_ACCEPTED = 'STATUS_ACCEPTED',
  STATUS_PAID = 'STATUS_PAID',
  STATUS_DECLINED = 'STATUS_DECLINED',
  STATUS_REFUNDED = 'STATUS_REFUNDED',
  STATUS_FAILED = 'STATUS_FAILED',
  STATUS_CANCELLED = 'STATUS_CANCELLED'
}
/* eslint-disable */
export enum PaymentSpecificStatusEnum {
  STATUS_SANTANDER_IN_PROGRESS = 'STATUS_SANTANDER_IN_PROGRESS', // Santander DE application state 0
  STATUS_SANTANDER_IN_PROCESS = 'STATUS_SANTANDER_IN_PROCESS', // Santander DE application state 1
  STATUS_SANTANDER_DECLINED = 'STATUS_SANTANDER_DECLINED', // Santander DE application state 2
  STATUS_SANTANDER_APPROVED = 'STATUS_SANTANDER_APPROVED', // Santander DE application state 3
  STATUS_SANTANDER_APPROVED_WITH_REQUIREMENTS = 'STATUS_SANTANDER_APPROVED_WITH_REQUIREMENTS', // Santander DE application state 4
  STATUS_SANTANDER_DEFERRED = 'STATUS_SANTANDER_DEFERRED', // Santander DE application state 5
  STATUS_SANTANDER_CANCELLED = 'STATUS_SANTANDER_CANCELLED', // Santander DE application state 6
  STATUS_SANTANDER_AUTOMATIC_DECLINE = 'STATUS_SANTANDER_AUTOMATIC_DECLINE', // Santander DE application state 7
  STATUS_SANTANDER_IN_DECISION = 'STATUS_SANTANDER_IN_DECISION', // Santander DE application state 8
  STATUS_SANTANDER_DECISION_NEXT_WORKING_DAY = 'STATUS_SANTANDER_DECISION_NEXT_WORKING_DAY', // Santander DE application state 9
  STATUS_SANTANDER_IN_CANCELLATION = 'STATUS_SANTANDER_IN_CANCELLATION', // Santander DE application state 10
  STATUS_SANTANDER_ACCOUNT_OPENED = 'STATUS_SANTANDER_ACCOUNT_OPENED', // Santander DE application state 11
  STATUS_SANTANDER_CANCELLED_ANOTHER = 'STATUS_SANTANDER_CANCELLED_ANOTHER', // Santander DE application state 12
  STATUS_SANTANDER_SHOP_TEMPORARY_APPROVED = 'STATUS_SANTANDER_SHOP_TEMPORARY_APPROVED', // Santander DE application state 13
  STATUS_SANTANDER_COMFORT_CARD_ISSUED = 'STATUS_SANTANDER_COMFORT_CARD_ISSUED', // Santander DE application state 14
  STATUS_PENDING = 'PENDING', // Santander SE
  STATUS_ACTIVATED = 'ACTIVATED', // Santander SE
  STATUS_APPROVED = 'APPROVED', // Santander SE
  STATUS_REJECTED = 'REJECTED', // Santander SE
  STATUS_SIGNED = 'SIGNED', // Santander SE + DE
  STATUS_CANCELLED = 'CANCELLED', // Santander SE
  STATUS_CONTROL = 'CONTROL', // DK
  NEED_MORE_INFO = 'NEED_MORE_INFO', // Santander SE
  NEED_MORE_INFO_IIR = 'NEED_MORE_INFO_IIR', // Santander NO
  NEED_MORE_INFO_DTI = 'NEED_MORE_INFO_DTI', // Santander NO
  NEED_MORE_INFO_SIFO = 'NEED_MORE_INFO_SIFO', // Santander NO
  NEED_MORE_INFO_STUDENT_IIR = 'NEED_MORE_INFO_STUDENT_IIR', // Santander NO
  NEED_MORE_INFO_STUDENT_SIFO = 'NEED_MORE_INFO_STUDENT_SIFO', // Santander NO
  NEED_CUSTOMER_APPROVAL = 'NEED_CUSTOMER_APPROVAL', // Santander NO
  // DE only:
  STATUS_GENEHMIGT = 'GENEHMIGT', // APPROVED
  STATUS_VERIFIED = 'VERIFIED',
  STATUS_ABGELEHNT = 'ABGELEHNT', // DECLINED
  STATUS_IN_BEARBEITUNG = 'IN_BEARBEITUNG',
  STATUS_IN_DECISION = 'IN_DECISION',
  STATUS_VERSENDET = 'VERSENDET',
  STATUS_IN_ENTSCHEIDUNG = 'IN_ENTSCHEIDUNG',
  STATUS_ZURUECKGESTELLT = 'ZURUECKGESTELLT'
}
